<nav aria-label="breadcrumb">
  <ul class="breadcrumb">

    <div *ngFor="let crumb of breadcrumbs; let last = last; let index = index;">
        <li *ngIf="( index ==0 && showFather ) || ( index !=0) "  [class.active]="last">
          <mat-icon  *ngIf="crumb.icon" [fontIcon]="crumb.icon"></mat-icon>
          <mat-icon *ngIf="crumb?.svgIcon" [svgIcon]="crumb?.svgIcon??''"></mat-icon>
          <a class="crumb-label" *ngIf="!last" [routerLink]="crumb.url" >{{
            crumb.label }}</a>
          <span class="crumb-label" *ngIf="last">{{ crumb.label }}</span>
          <span *ngIf="crumb.urlLabel && last">
            <mat-icon >arrow_forward_ios</mat-icon>
            <a class="crumb-label"  [routerLink]="crumb.linkTo">{{
              crumb.urlLabel }}</a>
          </span>
          
        </li>
    </div>
    
  </ul>
</nav>


